import { getAssetPath } from '@stencil/core';
import getEnv from './env';

export async function fetchAndStore(url: string): Promise<any> {
  try {

    const storedData = sessionStorage.getItem(url);
    if (!!storedData && JSON.parse(storedData).translationsExpiry > Date.now()) {
      return JSON.parse(storedData).translations;
    }

    return fetch(getAssetPath(url))
      .then((response) => response.json())
      .then((data) => replaceEnvValue(data))
      .then((data: any) => {
        sessionStorage.setItem(url, JSON.stringify({
          translations: data,
          translationsExpiry: Date.now() + (1 * 60 * 60 * 1000), // 1 hour
        }));
        return data;
      });

  } catch {
    return null;
  }
}

function replaceEnvValue<T>(obj: T): T {
  const env = getEnv();
  let newObj = JSON.stringify(obj);

  newObj = newObj.replaceAll('ENV_JOBSUCHE_URL', env.ENV_JOBSUCHE_URL);
  newObj = newObj.replaceAll('ENV_ARBEITSLOSENGELD_URL', env.ENV_ARBEITSLOSENGELD_URL);
  newObj = newObj.replaceAll('ENV_KINDERZUSCHLAG_URL', env.ENV_KINDERZUSCHLAG_URL);
  newObj = newObj.replaceAll('ENV_EINGLIEDERUNGSZUSCHUSS_URL', env.ENV_EINGLIEDERUNGSZUSCHUSS_URL);
  newObj = newObj.replaceAll('ENV_BETRIEBSNUMMER_URL', env.ENV_BETRIEBSNUMMER_URL);
  newObj = newObj.replaceAll('ENV_PROFIL_URL', env.ENV_PROFIL_URL);

  return JSON.parse(newObj);
}
